import { API_CONSTANT_MAP } from "./paths";
import requestApi from "./requestApi";

export type GetCartoesFiltro = {
  confirmado?: boolean;
  dataInicio?: string;
  dataFim?: string;
  unidadeIds?: number[];
  busca?: string;
};

export const getCartoes = async (filtro?: GetCartoesFiltro) => {
  const params = new URLSearchParams();
  if (filtro?.confirmado !== undefined) params.append("confirmado", String(filtro.confirmado));
  if (filtro?.dataInicio) params.append("dataInicio", filtro.dataInicio);
  if (filtro?.dataFim) params.append("dataFim", filtro.dataFim);
  filtro?.unidadeIds?.forEach((u) => params.append("unidadeIds", String(u)));
  if (filtro?.busca) params.append("busca", filtro.busca);

  const query = params.toString();
  const url = query ? `${API_CONSTANT_MAP.cartao}?${query}` : API_CONSTANT_MAP.cartao;
  return requestApi.get(url);
};

export const confirmarCartoes = (ids: number[]) => {
  return requestApi.put(`${API_CONSTANT_MAP.cartao}/confirmar`, { ids });
};
